<template>
  <div
    class="input-field"
    :class="{ 'error': validationError, 'bg-gray-300 rounded': disabled }"
  >
    <label v-if="label">
      {{ label }}
    </label>

    <IMaskComponent
      v-model:typed="model"
      :disabled="disabled"
      :mask="Number"
      :min="0"
      input-mode="decimal"
      thousands-separator=","
      :normalize-zeros="true"
      class="block border border-gray-300 w-full h-9 px-3 rounded"
    />

    <small v-if="hint">{{ hint }}</small>

    <span
      v-if="validationError"
      class="validation-error-message"
    >
      {{ validationError }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { IMaskComponent } from 'vue-imask';

defineProps({
  placeholder: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  focus: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: Object,
    default: () => null,
  },
  hint: {
    type: String,
    default: '',
  },
});

const model = defineModel();
</script>
